var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"history_box"},[_vm._m(0),_c('ul',{attrs:{"id":"historyList"}},_vm._l((_vm.list),function(item){return _c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.addKeywordsToSearchInput}},[_vm._v(_vm._s(item))])])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sug_history_title sug_title"},[_c('span',{staticClass:"fl"},[_vm._v("历史搜索")])])
}]

export { render, staticRenderFns }